import Channel from "controllers/channel";
import { notification } from "antd";
import api from "services/api";

export const createChannel = (channelName, handlers) =>
  new Channel(
    {
      channelName,
    },
    handlers
  );

export const formatChatData = (chatData, type = "realtime") => {
  const messages = chatData.lastMessage ? [chatData.lastMessage] : [];
  return { ...chatData, type, messages };
};

export const formatChatsCollection = (chats, type) =>
  chats.map((v) => formatChatData(v, type));

export const loadHistoryChats = () =>
  api
    .getHistoryChats()
    .then(({ data }) => formatChatsCollection(data, "paid_history"))
    .catch((error) => {
      notification["error"]({ message: "History chats has not been loaded" });
    });

export const loadArchivedHistoryChats = () =>
  api
    .getArchivedHistoryChats()
    .then(({ data }) => formatChatsCollection(data, "archive_history"))
    .catch((error) => {
      notification["error"]({ message: "Archived chats has not been loaded" });
    });

export const loadTrialHistoryChats = () =>
  api
    .getTrialHistoryChats()
    .then(({ data }) => formatChatsCollection(data, "trial_history"))
    .catch((error) => {
      notification["error"]({ message: "Trial chats has not been loaded" });
    });

export const loadHistoryWorkSessionChats = () =>
  api
    .getWorkSessionHistoryChats()
    .then(({ data }) => formatChatsCollection(data, "work_session_history"))
    .catch((error) => {
      notification["error"]({
        message: "Work session chats has not been loaded",
      });
    });
